// extracted by mini-css-extract-plugin
export default {"overlay":"Yx-z","bodyOpen":"Zx-z","content":"_x-z","header":"ay-z","closeNoHeading":"by-z"};